export interface TaskStateMapping {
  value: number;
  name: string;
}

export const TaskStateMappings: TaskStateMapping[] = [
  { value: 0, name: 'UNKNOWN' },
  { value: 1, name: 'Inactive' },
  { value: 2, name: 'In Progress' },
  { value: 3, name: 'Complete' },
  { value: 4, name: 'Abandoned' },
  { value: 5, name: 'Deleted' },
];
